import { UnitLabel } from '@/shared/config/config'
import { Alert, Button, NumericInputGroup } from '@/common'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StoredCO2Handling } from '@/features/production-routes/api/ProductionRouteModel'
import { useUpdateMethodEmissionReport } from '@/hooks/api/emissionReports'

export default function StoredCO2Reporting({
  close,
  storedCO2Handling,
  reportId,
  initialValue,
  processId
}: {
  close: () => void
  initialValue: { storedCO2AmountTonnes?: number }
  storedCO2Handling: StoredCO2Handling
  reportId: string
  processId: string
}) {
  const { mutate: updateMethodEmissionReport } = useUpdateMethodEmissionReport(reportId, processId)
  const { t } = useTranslation()

  const saveAndClose = async () => {
    await updateMethodEmissionReport({
      storedCO2AmountTonnes: Number(storedCO2AmountTonnes) || 0
    })
    close()
  }

  const [storedCO2AmountTonnes, setStoredCO2AmountTonnes] = useState<string>(
    initialValue?.storedCO2AmountTonnes || initialValue?.storedCO2AmountTonnes === 0
      ? initialValue?.storedCO2AmountTonnes.toString()
      : ''
  )

  return (
    <div className="space-y-4">
      <div className="space-y-4">
        <Alert type="info" className="whitespace-pre-line">
          {t('report:storedCO2.callout')}
          <br />
          <span className="font-bold">
            {t(`productionRoute:storedCO2.options.${storedCO2Handling}.title`)}
          </span>
        </Alert>
        <div className="space-y-2">
          <NumericInputGroup
            name="storedCO2AmountTonnes"
            label={t('report:storedCO2.fields.amount.label')}
            value={storedCO2AmountTonnes}
            suffix={UnitLabel.t}
            onChange={evt => setStoredCO2AmountTonnes(evt.target.value)}
            numericFormat={{
              decimalScale: 3,
              allowNegative: false
            }}
          />
        </div>
      </div>
      <footer className="gap-2 flex justify-end">
        <Button className="min-w-24" variant="neutral" onClick={close}>
          {t('common:actions:cancel')}
        </Button>
        <Button className="min-w-24" onClick={saveAndClose} disabled={storedCO2AmountTonnes === ''}>
          {t('common:actions:save')}
        </Button>
      </footer>
    </div>
  )
}
